import {
    MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE,
    MANAGEMENT_SAVED_SEARCH_WEBHOOKS_ROUTE,
    MANAGEMENT_SIGNALS_API_ROUTE,
    MANAGEMENT_SIGNALS_REST_API_ROUTE,
} from "app/pages/sales-intelligence/constants/sl_routes";
import { MANAGEMENT_APIS_AND_WEBHOOKS } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";

const BASE_BREADCRUMB = [
    {
        state: MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE,
        title: MANAGEMENT_APIS_AND_WEBHOOKS,
    },
];

export const SIGNALS_API_BREADCRUMBS = [
    ...BASE_BREADCRUMB,
    {
        state: MANAGEMENT_SIGNALS_API_ROUTE,
        title: "si.management.integration.signals-api.page.title",
    },
];

export const SIGNALS_REST_API_BREADCRUMBS = [
    ...BASE_BREADCRUMB,
    {
        state: MANAGEMENT_SIGNALS_REST_API_ROUTE,
        title: "si.management.integration.signals-rest-api.page.title",
    },
];

export const FIND_NEW_COMPANIES_API_BREADCRUMBS = [
    ...BASE_BREADCRUMB,
    {
        state: MANAGEMENT_SAVED_SEARCH_WEBHOOKS_ROUTE,
        title: "si.management.saved-search-webhooks.page.title",
    },
];
